// Email Campaign Request Types
export interface CreateCampaignRequest {
  BusinessId: string;
  EmailSubject: string;
  EmailContent: string;
  CampaignName: string; // Campaign name/description
  TargetGroupsId: number;
  SendType: number; // 1 = Send Now, 2 = Schedule
  SendOutDateTime?: string; // ISO 8601 UTC datetime string, required if SendType = 2
}

export interface UpdateCampaignRequest {
  BusinessId: string;
  CampaignId: string;
  EmailSubject: string;
  EmailContent: string;
  CampaignName: string; // Campaign name/description
  TargetGroupsId: number;
  SendType: number;
  SendOutDateTime?: string; // ISO 8601 UTC datetime string, required if SendType = 2
}

export interface SaveEmailCampaignConfigsRequest {
  BusinessId: string;
  HeaderBgColor: string;
  HeaderFontColor: string;
  ContentBorderColor: string;
  EmailCampaignLogo: string;
  TemplateName?: string;
  CampaignDescription?: string;
}

export interface SendTestCampaignRequest {
  BusinessId: string;
  CampaignId?: string;
  EmailSubject: string;
  EmailContent: string;
  TestEmails: string[];
}

export interface GetPatronListCountRequest {
  BusinessId: string;
  GroupId: number;
}

// Email Campaign Response Types
export interface EmailCampaignData {
  Id: number;
  CampaignId: string;
  EmailSubject: string;
  CampaignName: string; // Campaign name/description
  SendOutDateTime: string; // UTC datetime in ISO 8601 format
  DateCreated: string;
  Processed: number; // Campaign status: -1/0 = Scheduled, 1 = Sending, 2 = Sent
}

export interface EmailCampaignOpenRate {
  TotalSent: number;
  TotalOpened: number;
  OpenRate: number;
}

export interface TargetGroup {
  Id: number;
  TargetGroup: string;
}

export interface MerchantEmailCampaignSettings {
  HeaderBgColor: string;
  HeaderFontColor: string;
  ContentBorderColor: string;
  EmailCampaignLogo: string;
  MerchantLogo?: string;
  TemplateName: string;
  CampaignDescription: string;
  MerchantEstablishmentName: string;
}

export interface MerchantEmail {
  Id: number;
  CampaignId: string;
  EmailSubject: string;
  EmailContent: string;
  CampaignName: string; // Campaign name/description
  SendOutDateTime: string; // UTC datetime in ISO 8601 format
  DateCreated: string;
  HeaderBgColor: string;
  ContentBgColor: string;
  ContentBorderColor: string;
  MerchantLogo: string;
  TargetGroupsId: number;
  Processed: number; // Campaign status: -1/0 = Scheduled, 1 = Sending, 2 = Sent
  TemplateName: string;
  CampaignDescription: string;
  TempEmailSubject?: string;
  TempEmailContent?: string;
}

export interface CreateCampaignResponse {
  CampaignId: string;
  Success: boolean;
  Message: string;
}

// API Response wrapper
export interface ApiResponse<T> {
  success: boolean;
  data?: T;
  error?: string;
  message?: string;
}

// Form data types for components
export interface CampaignFormData {
  emailSubject: string;
  emailContent: string;
  campaignName: string; // Campaign name/description
  targetGroupId: number;
  sendType: number;
  sendOutDate?: string;
  sendOutTime?: string;
  testEmails: string[];
}

export interface EmailStylingFormData {
  headerBgColor: string;
  headerFontColor: string;
  contentBorderColor: string;
  emailCampaignLogo: string;
  templateName?: string;
  campaignDescription?: string;
}

// Enums
export enum SendType {
  SendNow = 1,
  Schedule = 2
}

export enum CampaignStatus {
  Draft = "draft",
  Scheduled = "scheduled",
  Sent = "sent",
  Failed = "failed"
}
